import { ErrorHandler } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { PlannerPageComponent } from './components/planner-page/planner-page.component';
import { PlannerStore } from './services/planner-store';
import { SentryErrorHandler, captureException } from './services/sentry-error-handler';

function readMeta(name: string): string {
  const el = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  return el?.content ?? '';
}

export function bootstrap(): void {
  const root = document.getElementById('planner-root');
  if (!root) {
    console.warn('[planner] #planner-root not found, skipping bootstrap');
    return;
  }

  bootstrapApplication(PlannerPageComponent, {
    providers: [{ provide: ErrorHandler, useClass: SentryErrorHandler }],
  })
    .then((appRef) => {
      const store = appRef.injector.get(PlannerStore);
      const tripId = readMeta('djir-trip-id') || null;
      const isLoggedIn = readMeta('djir-current-user') === 'true';
      const regionBoundsRaw = readMeta('djir-region-bounds');
      const regionBounds = regionBoundsRaw ? JSON.parse(regionBoundsRaw) : null;
      store.hydrate({ tripId, isLoggedIn, regionBounds }).catch((err) => {
        console.error('[planner] hydrate failed', err);
        captureException(err);
      });
    })
    .catch((err) => {
      console.error('[planner] bootstrap failed', err);
      captureException(err);
    });
}
